export default "__VITE_ASSET__d171c8f4__"